var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConsultation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    id: "Consellation--Streamline-Sharp",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Consellation Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "consellation--science-space-universe-star"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 3003",
    stroke: "#fff",
    d: "M19.5 7V1",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1218",
    stroke: "#fff",
    d: "M17 9.5a2.5 2.5 0 1 0 5 0 2.5 2.5 0 1 0 -5 0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1219",
    stroke: "#fff",
    d: "M11.5 19.5a2.5 2.5 0 1 0 5 0 2.5 2.5 0 1 0 -5 0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1220",
    stroke: "#fff",
    d: "M2 16a2.5 2.5 0 1 0 5 0 2.5 2.5 0 1 0 -5 0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1221",
    stroke: "#fff",
    d: "M5.5 6.5a2.5 2.5 0 1 0 5 0 2.5 2.5 0 1 0 -5 0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3002",
    stroke: "#fff",
    d: "m6.846 16.864 4.807 1.771",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3004",
    stroke: "#fff",
    d: "m15.205 17.309 3.09 -5.618",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3005",
    stroke: "#fff",
    d: "m7.136 8.846 -1.772 4.807",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3006",
    stroke: "#fff",
    d: "m17.08 8.868 -6.66 -1.737",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultation);
export default __webpack_public_path__ + "static/media/CONSULTATION.0879c6b8825799d3c6a0cfe5d5312d29.svg";
export { ForwardRef as ReactComponent };